<input
  #secureFieldInput
  autocomplete="off"
  data-lpignore="true"
  [type]="secureFieldType"
  [formControl]="formControl"
  [class.readonly]="column.isComputed"
  [attr.readonly]="column.isComputed ? true : null"
  class="input-string"
  (beforeinput)="secureFieldInputBeforeInputFn($event, formControl)"
  (focus)="secureFieldTypeFocusFn(secureFieldInput)"
  (click)="secureFieldTypeFocusFn(secureFieldInput)"
/>
@if (formControl.dirty) {
  <button (click)="changeSecureTextType(undefined, $event)" blazeIconButton class="password-icon">
    <mat-icon svgIcon="icon_preview_16" [class.!hidden]="secureFieldType === 'text'" />
    <mat-icon svgIcon="icon_preview_hidden_16" [class.!hidden]="secureFieldType === 'password'" />
  </button>
}
